module.exports = __webpack_public_path__ + "img/05.04491281.jpg";